import React from 'react'

import './profileui.css'
import Badge from 'react-bootstrap/Badge'

const Profile = ({ data }) => {
    return (
        <div className="row">
            <div className="profile-wrap col-lg-12 col-xl-12" style={{marginTop:'-25px'}}>

                <div className='prof-container'>
                    <div className='box'>
                        <img className='img-box' src={'https://emedia1.nhs.wales/HEIW2/cache/file/F4C33EF0-69EE-4445-94018B01ADCF6FD4.png'} alt="profile-img" />
                        <h2 className='name'>{data['name']}</h2>
                    </div>
                </div>
                <h5 className="" style={{ textAlign: 'center', marginLeft: '60px' }}>Profile Details </h5>
                <div className="profile-details d-flex">
                    <h4 className='des alert alert-primary'>Gender : {data['gender']}</h4>
                    <h4 className='des alert alert-primary'>Mobile : {data['mobileNumber']}</h4>
                    <h4 className='des alert alert-primary'>Interested In : {data['interestedIn']}</h4>
                </div>


                <h4 style={{ textAlign: 'center', marginLeft: '60px' }}> Profile Tags from your financial data</h4>
                {
                    data.tags.map((item) => {
                        return (
                            <Badge variant="success">{item}</Badge>
                        )
                    })
                }

                <div class="alert alert-warning alert-dismissible fade show mt-3" role="alert">
                    <strong> Check Explore Section to Find MATCH similar to your tags </strong>.

</div>







            </div>
        </div>
    )
}

export default Profile
